import { createReducer, on, Action } from '@ngrx/store';
import * as SupportCenterActions from './support-center.actions';
import {
  SupportCenterFolders,
  SupportCenterFile,
} from '@intellio/shared/models';

export const SUPPORT_CENTER_FEATURE_KEY = 'supportCenter';

export interface SupportCenterState {
  folders: SupportCenterFolders;
  foldersLoaded: boolean;
  files: Map<string, SupportCenterFile>;
  filesLoaded: Map<string, boolean>;
  filesLists: Map<string, SupportCenterFolders[]>;
  filesListsLoaded: Map<string, boolean>;
}

export interface SupportCenterPartialState {
  readonly [SUPPORT_CENTER_FEATURE_KEY]: SupportCenterState;
}

export const initialState: SupportCenterState = {
  folders: null,
  foldersLoaded: false,
  files: null,
  filesLoaded: null,
  filesLists: null,
  filesListsLoaded: null,
};

const supportCenterReducer = createReducer(
  initialState,
  on(SupportCenterActions.getFoldersSuccess, (state, { folders }) => ({
    ...state,
    folders,
    foldersLoaded: true,
  })),
  on(SupportCenterActions.getFoldersFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SupportCenterActions.getFilesSuccess, (state, { path, files }) => {
    let newFiles = new Map(state.files);
    let newFilesLoaded = new Map(state.filesLoaded);

    newFiles.set(path, files);
    newFilesLoaded.set(path, true);

    return { ...state, files: newFiles, filesLoaded: newFilesLoaded };
  }),
  on(SupportCenterActions.getFilesFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SupportCenterActions.getFilesListSuccess, (state, { path, filesList }) => {
    let newFilesLists = new Map(state.filesLists);
    let newFilesListsLoaded = new Map(state.filesListsLoaded);

    newFilesLists.set(path, filesList);
    newFilesListsLoaded.set(path, true);

    return {
      ...state,
      filesLists: newFilesLists,
      filesListsLoaded: newFilesListsLoaded,
    };
  }),
  on(SupportCenterActions.getFilesListFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function reducer(state: SupportCenterState | undefined, action: Action) {
  return supportCenterReducer(state, action);
}
